import script from "./CalendarEventsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CalendarEventsView.vue?vue&type=script&setup=true&lang=ts"

import "./CalendarEventsView.vue?vue&type=style&index=0&id=f885d650&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f885d650"]])

export default __exports__